import React from 'react';
import base from '../base';

class HeaderAboutMe extends React.Component {

  state = {
    desc: {}
  };

  componentDidMount() {
    this.ref = base.syncState("homepageDescription", {
      context: this,
      state: 'desc'
    });
  }


  componentDidUpdate() {
    document.getElementsByClassName('header-about-me')[0].innerHTML = String(this.state.desc);
    console.log("INNER HTML: " + document.getElementsByClassName('header-about-me')[0].innerHTML);

    this.props.onChange(this.state);
    //console.log("INNER = " + document.getElementsByClassName('header-about-me').innerHTML);
    //console.log("DeSsc: " + this.state.desc);
  }

  render() {

    /*

    if(this.state.desc === null) {
      return (
        <p className="header-about-me">
          Loading...
        </p>
      );
    }
    else {
      return (
        <p className="header-about-me">
          { ReactHtmlParser(value) }
        </p>
      );
    }
    */

    return (
      <p className="header-about-me">
        Loading...
      </p>
    );
  }
}

export default HeaderAboutMe;
